import flatten from 'lodash/flattenDeep';

export default function mergeRoutes(moduleRoutes) {
  return flatten(
    Object.keys(moduleRoutes).map((routeKey) =>
      typeof moduleRoutes[routeKey] === 'string'
        ? moduleRoutes[routeKey]
        : mergeRoutes(moduleRoutes[routeKey])
    )
  );
}
